<template>
  <div class="add-from-catalog">
    <div v-if="!isDraftOrPassiveSupplier">
      <div
        class="search-container"
      >
        <GInput
          v-model="params.searchTerm"
          @keyup.enter="onSearch"
          @input="onSearch"
          placeholder="Ürün Adı, Link veya Barkod ile Arayın"
          :class="{ 'full-width' : params.searchTerm === '' }"
        >
          <template #left-addon>
            <img
              class="form-search-icon"
              :src="`${$root.cdnUrl}assets/icon-search.png`"
            >
          </template>
        </GInput>
        <GBadge
          v-if="params.searchTerm !== ''"
          :class="{ 'has-no-filter' : getFilterCount === '0' }"
          :text="getFilterCount"
          :overlap="true"
        >
          <template>
            <GButton
              variant="secondary"
              @click="openFilterModal"
            >
              <img
                class="form-search-icon"
                :src="`${$root.cdnUrl}assets/filter-icon.svg`"
              >
            </GButton>
          </template>
        </GBadge>
      </div>
      <div
        v-if="params.searchTerm !== ''"
      >
        <div
          class="products-container"
        >
          <div
            v-for="item in result.content"
            :key="item.route"
            class="product"
            @click="push(item)"
          >
            <div
              class="image-container"
            >
              <CatalogImage
                :images="item.content.images"
              />
            </div>
            <div class="product-info">
              <span
                class="product-title"
                @click="openProductUrl(item.content.productUrl)"
              >{{ item.content.name || item.content.title }}</span>
              <ul class="product-attrs">
                <li>
                  Kategori:
                  <span>{{ item.content.categoryName }}</span>
                </li>
                <li>
                  Marka:
                  <span>{{ item.content.commonBrand ? `Genel Markalar - ${item.content.brandName}`: item.content.brandName }}</span>
                </li>
              </ul>
            </div>
            <div
              class="go-to-detail-button"
            >
              <img
                class="form-search-icon"
                :src="`${$root.cdnUrl}assets/icon-arrow-right.svg`"
              >
            </div>
          </div>
        </div>
        <div class="pagination-container">
          <Pagination
            :pagination="result"
            @page="setPage"
          />
        </div>
        <div
          v-if="result.content.length === 0 || params.searchTerm !== ''"
          class="not-found"
        >
          <p>
            Aradığınız ürün Trendyol kataloğunda yoksa
            hemen ekleyebilirsiniz.
          </p>
          <GButton
            @click="goToSingleProduct"
          >
            Tekil Ürün Oluştur
          </GButton>
        </div>
        <FilterModal
          :show="isFilterModalOpen"
          :params="params"
          :filters="filterNames"
          @filter="onFilter"
          @close="closeFilterModal"
        />
      </div>
      <div
        class="opening-page"
        v-else
      >
        <GAlert
          variant="warning"
          :show-icon="false"
        >
          <img :src="`${$root.cdnUrl}assets/warning-icon-filled-with-orange.svg`">
          Seçeceğiniz ürünün, sizin ürününüzle aynı
          olduğundan emin olmalısınız. Farklı bir ürün
          gönderildiğinde satışınız durdurulabilir.
        </GAlert>
        <img
          class="form-search-icon"
          :src="`${$root.cdnUrl}assets/catalog-image.svg`"
        >
        <h2>Ürün Girmek ve Satışa Açmak Çok Kolay!</h2>
        <p>Satışını yapmak istediğiniz ürünü mağazanıza eklemek için ürün adı, barkod veya ürün linkini kullanarak Trendyol kataloğunda aratabilirsiniz.</p>
      </div>
    </div>
    <SupplierStatusPage v-else />
  </div>
</template>
<script>
import singleProductService from '@/services/singleProduct';
import GButton from '@trendyol-js/grace/core/GButton';
import GInput from '@trendyol-js/grace/core/GInput';
import GAlert from '@trendyol-js/grace/core/GAlert';
import GBadge from '@trendyol-js/grace/core/GBadge';
import CatalogImage from '@/pages/AddFromCatalog/Components/CatalogImage';
import routerPush from '@/mixins/routerPush';
import FilterModal from './Modals/FilterModal';
import Pagination from '@/pages/AddFromCatalog/Components/Pagination';
import spinner from '@/utils/spinner';
import SupplierStatusPage from './Components/SupplierStatusPage.vue';
import supplierService from '../../services/supplier';
let searchTimeout;
export default {
  name: 'Search',
  components: {
    FilterModal,
    CatalogImage,
    GInput,
    GAlert,
    GButton,
    GBadge,
    Pagination,
    SupplierStatusPage,
  },
  mixins: [routerPush],
  data () {
    return {
      params: {
        searchTerm: '',
        page: 0,
        pageSize: 12,
        order: null,
        orderBy: null,
        barcode: null,
        stockCode: null,
        productMainId: null,
        brandIds: [],
        categoryIds: [],
      },
      filterNames: {
        category: [],
        brand: [],
      },
      result: {
        content: [],
        page: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
      },
      selectedBarcode: '',
      isFilterModalOpen: false,
      supplierDetail: {},
    };
  },
  computed: {
    getFilterCount () {
      const result = this.filterNames.category?.length + this.filterNames.brand?.length;
      return (result).toString();
    },
    isDraftOrPassiveSupplier () {
      return this.supplierDetail.status === 'PASSIVE' || this.supplierDetail.status === 'DRAFT';
    },
  },
  methods: {
    /* helpers */
    push (params) {
      const barcode = this.selectedBarcode;
      const contentId = this.trendyolUrlMatcher(params.content.productUrl);
      if (this.selectedBarcode.length > 0) {
        const isBarcodeSelected = params.variants.find(variant => variant.barcode === this.selectedBarcode);
        if (isBarcodeSelected) {
          this.routerPush('CatalogDetail', { contentId }, { query: { barcode } });
        } else {
          this.routerPush('CatalogDetail', { contentId });
        }
      } else {
        this.routerPush('CatalogDetail', { contentId });
      }
    },
    goToSingleProduct () {
      this.routerPush('SingleProduct');
    },
    openFilterModal () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal () {
      this.isFilterModalOpen = false;
    },
    async onSearch () {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(async () => {
        await this.getProducts();
      }, 500);
    },
    onFilter (params, filterNames) {
      this.filterNames = filterNames;
      this.params = params;
      this.params.page = 0;
      this.getProducts();
      this.closeFilterModal();
    },
    async setPage (page) {
      this.result.page = page;
      this.params.page = page;
      await this.getProducts();
    },
    trendyolUrlMatcher (text) {
      if (!text.includes('trendyol')) {
        return false;
      }

      // eslint-disable-next-line no-useless-escape
      const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
      const regex = new RegExp(expression);
      if (!text.match(regex)) {
        return false;
      }

      const splittedText = text.split('-');
      const lastElement = splittedText[splittedText.length - 1];
      if (lastElement.includes('?')) {
        return lastElement.split('?')[0];
      }

      return lastElement;
    },
    /* helpers done */
    /* helper business functions */
    _getVarianterFromProduct (contents) {
      return contents.map(content => ({
        barcode: content.barcode,
        attributes: content.productAttributes ? content.productAttributes.filter(attr => attr.varianter === true) : [],
        exist: content.exist,
      }));
    },
    _getContentFromProduct (contents) {
      return contents.map(content => ({
        attributes:
            content.productAttributes ? content.productAttributes
              .filter(attr => attr.varianter === false)
              .map(attr => ({ ...attr, valueName: attr.customValue }))
              : [],
        ...content,
      }))[0];
    },
    _createContentGroupFromProductsResponse (items) {
      let contentGroup = {};
      contentGroup = items.reduce((r, a) => {
        r[a.pimContentId] = [...r[a.pimContentId] || [], a];
        return r;
      }, {});
      return contentGroup;
    },
    _createContentResponse (contentGroup) {
      const contentResponse = [];
      // eslint-disable-next-line no-unused-vars
      for (const [_, value] of Object.entries(contentGroup)) {
        contentResponse.push({
          variants: this._getVarianterFromProduct(value),
          content: this._getContentFromProduct(value),
        });
      }

      return contentResponse;
    },

    /* helper business functions done */
    async getProductGroupViaName (pageSize) {
      const searchTerm = this.params.searchTerm;
      try {
        const params = {
          ...this.params,
          pageSize,
          name: searchTerm,
          page: this.params.page,
        };
        const response = await singleProductService.getProductGroupViaName(params);
        return response;
      } catch (err) {
        if (err) {
          return {
            content: [],
            page: 0,
            size: 0,
            totalElements: 0,
            totalPages: 0,
          };
        }
      }
    },
    openProductUrl (href) {
      const a = document.createElement('a');
      a.href = href;
      a.target = '_blank';
      a.click();
    },
    async getProductsByContentIdOrBarcode (params) {
      params.page = 0;
      const result = {};
      let rawItems = [];
      const searchTerm = params.searchTerm.trim();
      const tyUrlMatcher = this.trendyolUrlMatcher(searchTerm);
      try {
        if (tyUrlMatcher) {
          rawItems = await singleProductService
            .getProductViaContentId(tyUrlMatcher, params);
        } else {
          rawItems = await singleProductService
            .getByBarcode(params.searchTerm.trim(), params).catch(() => null);
          if (rawItems) {
            this.selectedBarcode = params.searchTerm.trim();
          }
        }
        if (rawItems) {
          const items = rawItems.content;

          const contentGroup = this._createContentGroupFromProductsResponse(items);
          const contentResponse = this._createContentResponse(contentGroup);
          result.contentGroup = contentGroup;
          result.contentResponse = contentResponse;
          result.fromUrl = tyUrlMatcher;
          return result;
        }
      } catch {
        return null;
      };
    },
    async getProducts () {
      const params = { ...this.params };
      let fromUrl = false;
      let contentGroup = {};
      let contentResponse = [];
      // at first request
      if (params.page === 0) {
        const generatedResponse = await this.getProductsByContentIdOrBarcode(params);
        if (generatedResponse) {
          contentGroup = generatedResponse.contentGroup;
          contentResponse = generatedResponse.contentResponse;
          fromUrl = generatedResponse.fromUrl;
        }
      }
      if (!fromUrl) {
        const contentPageSize = 12 - Object.keys(contentGroup).length % 3;

        const { content, page, size, totalElements, totalPages } = await this.getProductGroupViaName(contentPageSize);
        this.result = {
          content: [...content, ...contentResponse],
          page,
          size: size + contentResponse.length, // params.size
          totalElements: totalElements + contentResponse.length || 0,
          totalPages,
        };
      } else {
        this.result = {
          content: [...contentResponse],
          page: 0,
          size: contentResponse.length,
          totalElements: contentResponse.length || 0,
          totalPages: 0,
        };
      }
    },
  },
  async created () {
    spinner.done();
    try {
      const { marketPlaceDetail } = await supplierService.getSupplierDetail();
      this.supplierDetail = marketPlaceDetail;
    } catch (error) {}
  },
};
</script>
<style lang="scss" scoped>
.add-from-catalog {
  .search-container {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    ::v-deep .has-no-filter {
      .badge {
        display: none;
      }
    }
    ::v-deep .g-badge {
      .badge {
        background: #f27a1a;
      }
    }
    .full-width {
      width: 100% !important;
    }
    ::v-deep .g-input {
      position: relative;
      width: calc(100% - 50px);
      img {
        position: absolute;
        top: 10px;
        left: 15px;
        width: 18px;
      }
      .content {
        border: 1px solid #DEE0EB;
        border-radius: 6px !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #273142;
        padding-left: 38px;
      }
    }
    ::v-deep .g-button {
      .content {
        max-width: 40px !important;
        height: 40px;
        padding: 10px;
        background: #273142;
        border-radius: 6px;
      }
    }
  }
  .not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    gap: 12px;
    p {
      text-align: center;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #273142;
    }
    .g-button {
      width: 100%;
      height: 50px;
    }
  }
  .opening-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    gap: 20px;
    ::v-deep .g-alert {
      background: #FFF8E6;
      border: solid 1px #FFB600;
      .content {
        display: flex;
        gap: 8px;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        color: #273142;
        width: 90%;
        img {
          width: 16px;
        }
      }
    }
    img {
      width: 140px;
    }
    h2 {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #273142;
    }
    p {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #6E7787;
    }
  }
  .products-container {
    .product {
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #DEE0EB;
      .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px !important;
        img {
          max-width: 45px;
        }
      }
      .product-info {
        min-width: 250px;
        width: calc(100% - 100px);
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #273142;
        padding: 10px 0;
        .product-title {
          text-decoration: underline;
        }
        .product-attrs {
          padding: 0;
          margin: 0;
          list-style-type: none;
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
          color: #95A1B5;
          li{
            margin-top: 5px;
            span {
              margin-left: 4px;
              font-weight: 500 !important;
              color: #273142;
            }
          }
        }
      }
      .go-to-detail-button {
        display: flex;
        width: 30px;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
